import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { CompanyGroup } from '@shared/models/company-group';

@Injectable({ providedIn: 'root' })
export class EnvironmentService {
    public headersOption: any = {};

    constructor() {}

    public getHeaderOptions(): any {
        const whitelabel = localStorage.getItem('CURRENT_WHITELABEL');
        switch (whitelabel) {
            case 'blu':
                return this.setHeaderOptions(
                    'BLU-CORP',
                    '186e4dd5beed4e09a19c6205fd605990'
                );
                break;
            case 'anz':
                return this.setHeaderOptions(
                    'ANZ-CORP',
                    'f5c4e0b1cfc7448483fd20a85d1775de'
                );
                break;
            default:
                return this.setHeaderOptions(
                    environment.application_id,
                    environment.application_key
                );
        }
    }

    public getLandingPage(tenant: string): string {
        //todo fix this solution w a proper config later
        if (tenant.indexOf(CompanyGroup.BLU) !== -1) {
            return '/deposit';
        }
        return '/customer/account';
    }

    public setHeaderOptions(appId, appKey): any {
        return (this.headersOption = {
            'Content-Type': 'application/json',
            application_id: appId,
            application_key: appKey,
        });
    }
}
